import { ENDPOINTS } from 'api/endpoints';
import { useGetQuery } from 'api/useGetQuery';
import logo from 'assets/images/solovis-logo.png';
import { useDataEnvironment } from 'contexts/DataEnvironmentContext';
import React from 'react';

type UserData = {
  id: string;
  code: string;
  primaryEmail: string;
  fullName: string;
};

const Header: React.FC = () => {
  const [dataEnvironment] = useDataEnvironment();
  const { isLoading, data: userData } = useGetQuery<UserData>(ENDPOINTS.user());
  const host = window.location.host.replace('leap.', '');
  const urlPrefix = `https://${dataEnvironment?.subdomain}.${host}`;

  return (
    <>
      <header>
        <div
          className="navbar shadow-sm p-0 m-0"
          style={{ backgroundColor: '#08062A', height: 48, paddingLeft: 15, paddingRight: 15 }}>
          <div className="container-fluid" style={{ paddingLeft: 0 }}>
            <div
              className="row"
              style={{
                margin: 0,
                width: '100%',
                color: '#bbb',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
              <div
                className="col-sm"
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  paddingLeft: 0,
                  alignItems: 'center',
                  fontSize: 15,
                }}>
                <div
                  style={{
                    width: 48,
                    height: 48,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}>
                  <img src={logo} alt="Solovis" />
                </div>

                <span
                  className="text-left"
                  style={{ paddingLeft: 10, fontSize: 15, color: '#fff', display: 'inline-block' }}>
                  {dataEnvironment!.name}
                </span>
              </div>
              <div
                className="col-sm text-right text-light"
                style={{
                  display: 'flex',
                  justifyContent: 'end',
                  alignItems: 'center',
                  height: 48,
                  fontSize: 12,
                }}>
                <a
                  href={`${urlPrefix}/MyAccount`}
                  style={{ display: 'block' }}
                  className="text-white">
                  <strong>{isLoading ? '' : userData!.fullName}</strong>
                </a>
              </div>
            </div>
          </div>
        </div>
      </header>
      <header>
        <div
          className="navbar shadow-sm p-0 m-0"
          style={{ backgroundColor: '#00516b', height: 32, paddingLeft: 15, paddingRight: 15 }}>
          <div className="container-fluid" style={{ justifyContent: 'flex-start' }}>
            <a
              className="text-white"
              style={{
                paddingLeft: 1,
                paddingRight: 10,
                marginRight: 3,
                fontSize: 12,
                fontWeight: 500,
                fontFamily: '"Segoe UI",Arial,Helvetica,Sans-Serif',
              }}
              href={`${urlPrefix}/ReportData/ViewReport?reportAlias=MainDashboard`}>
              DASHBOARD
            </a>
            <a
              className="text-white"
              style={{
                paddingLeft: 10,
                paddingRight: 10,
                marginRight: 3,
                fontSize: 12,
                fontWeight: 500,
                fontFamily: '"Segoe UI",Arial,Helvetica,Sans-Serif',
              }}
              href={`${urlPrefix}/ReportData/ViewReport?reportAlias=AssetsDashboard`}>
              ASSETS
            </a>
            <a
              className="text-white"
              style={{
                paddingLeft: 10,
                paddingRight: 10,
                marginRight: 3,
                fontSize: 12,
                fontWeight: 500,
                fontFamily: '"Segoe UI",Arial,Helvetica,Sans-Serif',
              }}
              href={`${urlPrefix}/Data`}>
              DATA
            </a>
            <a
              className="text-white"
              style={{
                paddingLeft: 10,
                paddingRight: 10,
                marginRight: 3,
                fontSize: 12,
                fontWeight: 500,
                fontFamily: '"Segoe UI",Arial,Helvetica,Sans-Serif',
              }}
              href={`${urlPrefix}/ReportData/ViewReport?reportAlias=Reports`}>
              REPORTS
            </a>
          </div>
        </div>
      </header>
      <header>
        <div className="p-0 mt-3" style={{ marginTop: 20, paddingLeft: 15, paddingRight: 15 }}>
          <div className="container-fluid">
            <h1 className="p-0 m-0" style={{ fontWeight: 'bold', fontSize: 21, color: '#006F93' }}>
              Solovis x eVestment Connectivity
            </h1>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
